import { takeLatest, put, call, fork } from 'redux-saga/effects';

import { findUsuarioProdutorDetails } from '../service';
import {
  FIND_USUARIO_PRODUTOR_DETAILS,
  FIND_USUARIO_PRODUTOR_DETAILS_PENDING,
  FIND_USUARIO_PRODUTOR_DETAILS_SUCCESS,
  FIND_USUARIO_PRODUTOR_DETAILS_FAILURE,
} from '../actionTypes';

function* sagaFindUsuarioProdutorDetails(action) {
  yield put({ type: FIND_USUARIO_PRODUTOR_DETAILS_PENDING, id: action.id });

  try {
    const usuarioDetails = yield call(findUsuarioProdutorDetails, action.id);
    yield put({ type: FIND_USUARIO_PRODUTOR_DETAILS_SUCCESS, usuarioDetails });
  } catch (error) {
    yield put({ type: FIND_USUARIO_PRODUTOR_DETAILS_FAILURE });
  }
}

export function* watchFindUsuarioProdutorDetails() {
  yield takeLatest(
    FIND_USUARIO_PRODUTOR_DETAILS,
    sagaFindUsuarioProdutorDetails,
  );
}

export default function* watchFindSagas() {
  yield fork(watchFindUsuarioProdutorDetails);
}
